/**
 * Site geneli tarih/saat — tek kaynak.
 * Değiştirmek için .env:
 *   NEXT_PUBLIC_SITE_TIMEZONE=Europe/Istanbul
 *   NEXT_PUBLIC_SITE_LOCALE=tr-TR
 * (TZ yoksa next.config aynı timezone’u process.env.TZ’ye yazar)
 */

function envOr(name: string, fallback: string): string {
  const v = process.env[name]?.trim()
  return v || fallback
}

export const SITE_LOCALE = envOr('NEXT_PUBLIC_SITE_LOCALE', 'tr-TR')

export const SITE_TIMEZONE = envOr(
  'NEXT_PUBLIC_SITE_TIMEZONE',
  envOr('TZ', 'Europe/Istanbul'),
)

export function formatSiteDateTime(
  value: Date | string | number | null | undefined,
  options?: Intl.DateTimeFormatOptions,
): string {
  if (value == null || value === '') return '—'
  const date = value instanceof Date ? value : new Date(value)
  if (!Number.isFinite(date.getTime())) return '—'
  return date.toLocaleString(SITE_LOCALE, {
    timeZone: SITE_TIMEZONE,
    ...options,
  })
}

export function formatSiteDate(
  value: Date | string | number | null | undefined,
  options?: Intl.DateTimeFormatOptions,
): string {
  if (value == null || value === '') return '—'
  const date = value instanceof Date ? value : new Date(value)
  if (!Number.isFinite(date.getTime())) return '—'
  return date.toLocaleDateString(SITE_LOCALE, {
    timeZone: SITE_TIMEZONE,
    ...options,
  })
}

export function formatSiteTime(
  value: Date | string | number | null | undefined,
  options?: Intl.DateTimeFormatOptions,
): string {
  if (value == null || value === '') return '—'
  const date = value instanceof Date ? value : new Date(value)
  if (!Number.isFinite(date.getTime())) return '—'
  return date.toLocaleTimeString(SITE_LOCALE, {
    timeZone: SITE_TIMEZONE,
    ...options,
  })
}
